import apiClient from '../../../lib/axios';

export const fetchDocumentTypes = async ({ page = 1, pageSize = 10, isActive, search } = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', pageSize);
  if (typeof isActive === 'boolean') params.append('isActive', isActive);
  if (search) params.append('search', search);
  const { data } = await apiClient.get(`/api/document-types?${params.toString()}`);
  return data;
};

export const fetchActiveDocumentTypes = async () => {
  const { data } = await apiClient.get('/api/document-types/active');

 // console.log(data);
  return data;
};

export const fetchDocumentTypeById = async (id) => {
  const { data } = await apiClient.get(`/api/document-types/${id}`);
  return data;
};

export const createDocumentType = async (payload) => {
  const { data } = await apiClient.post('/api/document-types', payload);
  return data;
};

export const updateDocumentType = async ({ id, payload }) => {
  const { data } = await apiClient.patch(`/api/document-types/${id}`, payload);
  return data;
};

export const deleteDocumentType = async (id) => {
  const { data } = await apiClient.delete(`/api/document-types/${id}`);
  return data;
};

export default fetchDocumentTypes;
